import PageShell from "@/components/PageShell";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SUBSIDIARIES } from "@/lib/content";
import { subsidiaryLogo } from "@/lib/assets";

export default function Companies() {
  return (
    <PageShell
      testId="companies-page"
      title="Our Companies — Salihi Group"
      description="Explore the seven subsidiaries of Salihi Group: Salihi Law, Salihi Consulting, Salihi Mining, Salihi Engineering, Salihi Investment, Kaafi Hire Employment Services, and Salihi Oil & Gas."
      eyebrow="Group Companies"
      heading={<>Our <em className="text-gold not-italic">companies</em>.</>}
      subheading="Seven specialised subsidiaries, one professional standard."
      breadcrumbs={[{ label: "Our Companies" }]}
    >
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {SUBSIDIARIES.map((s, idx) => (
          <Link
            key={s.slug}
            to={`/companies/${s.slug}`}
            data-testid={`companies-card-${s.slug}`}
            className="group bg-white border border-softgray p-8 md:p-10 flex flex-col
                       hover:border-gold hover:shadow-[0_20px_60px_-20px_rgba(15,42,92,0.18)]
                       transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1"
          >
            <div className="absolute -mt-4 ml-auto self-end text-[11px] text-mutedink font-mono tabular-nums">0{idx + 1}</div>
            <div className="h-[100px] md:h-[110px] flex items-center justify-center mb-6">
              <img
                src={subsidiaryLogo(s)}
                alt={`${s.name} logo`}
                className="max-h-full max-w-full w-auto object-contain transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="w-10 h-[1.5px] bg-gold mb-4 mx-auto" />
            <h2 className="font-serif text-navy text-xl leading-tight text-center mb-2">{s.name}</h2>
            <div className="text-gold text-[11px] uppercase tracking-[0.24em] text-center mb-4">{s.tagline}</div>
            <p className="text-mutedink text-[14px] leading-relaxed font-light text-center min-h-[4rem]">
              {s.description}
            </p>
            <div className="mt-auto pt-6 flex justify-center">
              <span className="inline-flex items-center gap-2 text-navy text-xs uppercase tracking-[0.18em] font-semibold group-hover:text-gold transition-colors">
                Visit Company Page
                <ArrowUpRight size={14} strokeWidth={2} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </PageShell>
  );
}
